module.exports = __webpack_public_path__ + "static/media/2_image3.0308cd81.jpg";